import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    display: 'flex',
    paddingVertical: 15,
    alignItems: 'center',
  },
  emptyText: {
    textAlign: 'center',
  },
  searchWidth:{
    width: 432
  },
  infoMessage:{
    flex: 1, 
    textAlign: 'right'
  }
});